import React from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { CategoryCard } from "@app/components";
import { Strings } from "@app/constants";
import { useNavigate } from "react-router-dom";

interface CategoriesProps {
  categories: any;
  DialogBoxPopUp?: any;
  isOuterRefrence?: any;
}

const Categories = ({ categories, DialogBoxPopUp }: CategoriesProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  return (
    <Stack
      sx={{
        backgroundColor: theme.palette.primary.main,
        py: { xs: 4, md: 5 },
        px: { xs: 2, sm: 3 },
      }}
    >
      <Stack
        sx={{
          width: "100%",
          maxWidth: 1120,
          alignSelf: "center",
        }}
      >
        <Stack sx={{ width: "100%", mb: { xs: 2.5, md: 3 } }}>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontFamily: "Work Sans",
              fontSize: { xs: 22, sm: 26, md: 30 },
              fontWeight: 800,
              lineHeight: 1.2,
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            {Strings.heading.categoriesForYou}
          </Typography>
        </Stack>

        <Grid
          container
          spacing={{ xs: 2.5, md: 3 }}
          justifyContent="center"
          alignItems="stretch"
        >
          {categories?.map(
            (
              category: {
                title: string;
                description: string;
                image: string;
                path: string;
                isOuterRefrence: boolean;
                buttonText?: string;
              },
              index: React.Key,
            ) => (
              <Grid
                key={index}
                size={{ xs: 12, sm: 6, md: 4 }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CategoryCard
                  title={category?.title}
                  description={category?.description}
                  image={category?.image}
                  buttonText={category?.buttonText}
                  onClick={() => {
                    if (category?.path) {
                      if (category?.isOuterRefrence) {
                        window.location.href = category?.path;
                      } else {
                        navigate(category?.path);
                      }
                    } else {
                      DialogBoxPopUp?.show();
                    }
                  }}
                />
              </Grid>
            ),
          )}
        </Grid>
      </Stack>
    </Stack>
  );
};

export { Categories };
